"use client";

import * as React from "react";
import { cn } from "@marketing-sites/utils/cn";
import { IntercomLogoIcon } from "../icons/intercom-logo-icon";
import { NavigationLink } from "./navigation-link";

type LogoProps = {
  /** Whether the logo should be a clickable link */
  asLink?: boolean;
  /** Custom className for the logo icon */
  className?: string;
  /** Custom href (defaults to https://www.intercom.com) */
  href?: string;
  /** Custom icon to render instead of the default IntercomLogoIcon */
  icon?: React.ReactNode;
  /** Custom label for the logo */
  label: string;
  /** Override the text sent in the navItemClick analytics event (defaults to label) */
  analyticsText?: string;
  /** Stable slug for the navItemClick event, so the identifier never keys on
   *  rendered copy. */
  analyticsId: string;
};

export const Logo = ({
  asLink = true,
  className,
  href = "https://www.intercom.com",
  icon,
  label,
  analyticsText,
  analyticsId,
}: LogoProps) => {
  const logoIcon = icon ?? <IntercomLogoIcon />;

  if (!asLink) {
    return logoIcon;
  }

  return (
    <NavigationLink
      href={href}
      text={label}
      analyticsText={analyticsText}
      analyticsId={analyticsId}
      ariaLabel={label}
      location="Main Nav"
    >
      <span className={cn("text-nav-content-primary", className)}>
        {logoIcon}
      </span>
    </NavigationLink>
  );
};
